import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/resources/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/resources/download",
    })
  },
})
